export default "__VITE_ASSET__DLddv_xR__"